import { Box, Typography } from "@mui/material"
import type { FC, ReactNode } from "react"

interface AccountDetailsFieldProps {
  label: string
  value: ReactNode
}

export const AccountDetailsField: FC<AccountDetailsFieldProps> = ({ label, value }) => (
  <Box>
    <Typography variant='caption' className='font-bold text-gray-600'>
      {label}
    </Typography>
    <Typography variant='body2' className='mt-1 text-gray-900'>
      {value}
    </Typography>
  </Box>
)
